export default __webpack_public_path__ + "static/media/Ms.Kiran_Deshmukh.8e0a47b3.png";